var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 57,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "m26.886 34.11 17.978-17.855a2.79 2.79 0 0 0 0-4.004 2.836 2.836 0 0 0-4.031 0L22.855 30.027 4.877 12.17a2.836 2.836 0 0 0-4.03 0 2.79 2.79 0 0 0 0 4.004L18.823 34.03.846 51.966a2.79 2.79 0 0 0 0 4.003c.565.56 1.29.801 2.016.801.725 0 1.451-.24 2.015-.8l17.978-17.856 17.978 17.855c.564.56 1.29.801 2.015.801s1.451-.24 2.016-.8a2.79 2.79 0 0 0 0-4.004z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M22.85 5.285c1.37 0 2.579 1.12 2.579 2.562a2.59 2.59 0 0 1-2.58 2.562c-1.37 0-2.58-1.12-2.58-2.562s1.13-2.562 2.58-2.562m0 10.249c4.272 0 7.82-3.443 7.82-7.767C30.67 3.523 27.202 0 22.85 0c-4.354 0-7.82 3.443-7.82 7.767s3.547 7.767 7.82 7.767"
  })));
};
export default SvgX;